<template>
  <div class="viewbox bottom-tabbar">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"/>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"/>
    <van-tabbar
      v-model="active"
      active-color="#DB2D2D"
      v-if="$route.meta.keepAlive && !$route.meta.noTabbar"
    >
      <van-tabbar-item to="/mall">
        <i
          class="iconfont iconshujishangcheng"
          slot="icon"
          slot-scope="props"
          :class="{'active': props.active}"
        />
        商城
      </van-tabbar-item>
      <van-tabbar-item to="/user">
        <i
          class="iconfont icongerenzhongxin"
          slot="icon"
          slot-scope="props"
          :class="{'active': props.active}"
        />
        个人中心
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
  export default {
    name: 'tabBarLayout',
    data () {
      return {
        active: null
      }
    },
    watch: {
      $route () {
        this.active = this.activeIndex()
      }
    },
    created () {
      this.active = this.activeIndex()
    },
    methods: {
      activeIndex: function () {
        let { name } = this.$route
        let index = {
          'mallIndex': 0,
          'userIndex': 1
        }
        return index[name] ? index[name] : 0
      }
    }
  }
</script>

<style lang="stylus">
</style>